module.exports = __webpack_public_path__ + "static/media/IMG_4429.5817c391.JPG";